import styled, { css, keyframes } from "styled-components";

import { borderRadius } from "../../tokens";

export const rippleAnimation = keyframes`
  0% {
    box-shadow:
      0 0 0 0 rgba(25, 97, 231, 0.5),
      0 0 0 0 rgba(25, 97, 231, 0.3);
  }
  60% {
    box-shadow:
      0 0 0 8px rgba(25, 97, 231, 0.15),
      0 0 0 16px rgba(25, 97, 231, 0.05);
  }
  100% {
    box-shadow:
      0 0 0 12px rgba(25, 97, 231, 0),
      0 0 0 24px rgba(25, 97, 231, 0);
  }
`;

export interface BlinkWrapperProps {
  $blink: boolean;
  /** Number of ripple pulses, or "infinite" to keep pulsing until $blink is false. Defaults to 6. */
  $iterationCount?: number | "infinite";
}

/**
 * Wraps an element (typically a button) with a ripple/pulse effect used to
 * draw attention to it, e.g. the Documents "Upload" button or a Submit
 * button that still has unsubmitted draft data.
 */
export const BlinkWrapper = styled.div<BlinkWrapperProps>`
  border-radius: ${borderRadius.subtle}rem;
  ${({ $blink, $iterationCount = 6 }) =>
    $blink &&
    css`
      animation: ${rippleAnimation} 0.9s ease-out ${$iterationCount};
    `}
`;
